import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getMultiLangProperty } from "../../../../helpers/generalHelper";

const MobileNavMenu = () => {
  const { t, i18n } = useTranslation();

  const Category = useSelector((state) => state.category);

  const [categories, setCategories] = useState([]);

  const filterEnabledCategories = (categoryList) =>
    categoryList
      .filter(
        (item) =>
          item.status === "enabled" || item.category?.status === "enabled"
      )
      .reduce((output, item) => {
        const { children, category: subCategory } = item;
        if (Array.isArray(children)) {
          output.push({
            ...item,
            children: filterEnabledCategories(children),
          });
        } else if (Array.isArray(subCategory?.children)) {
          output.push({
            ...item,
            category: {
              ...subCategory,
              children: filterEnabledCategories(subCategory.children),
            },
          });
        } else {
          output.push(item);
        }
        return output;
      }, []);

  useEffect(() => {
    setCategories(filterEnabledCategories(Category));
  }, [Category]);

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul>
        <li className="menu-item-has-children">
          <Link
            to={{
              pathname: `/browse/`,
            }}
          >
            {t("productList.allProducts")}
          </Link>
        </li>

        {Array.isArray(categories) &&
          categories.map((parentCategory) => (
            <li className="menu-item-has-children" key={parentCategory._id}>
              {Array.isArray(parentCategory.children) &&
                parentCategory.children.length >= 1 && (
                  <Link
                    to={{
                      pathname: `/browse/${parentCategory.slug}`,
                    }}
                  >
                    {getMultiLangProperty(parentCategory.name, i18n.language)}
                  </Link>
                )}

              {Array.isArray(parentCategory.children) &&
              parentCategory.children.length >= 1 ? (
                <ul className="sub-menu">
                  {parentCategory.children.map(
                    ({ category: subCategory = {} }) => (
                      <li
                        className="menu-item-has-children"
                        key={subCategory._id}
                      >
                        {Array.isArray(subCategory.children) &&
                          subCategory.children.length >= 1 && (
                            <Link
                              to={{
                                pathname: `/browse/${subCategory.slug}`,
                              }}
                            >
                              {getMultiLangProperty(
                                subCategory.name,
                                i18n.language
                              )}
                            </Link>
                          )}
                        {Array.isArray(subCategory.children) &&
                        subCategory.children.length >= 1 ? (
                          <ul className="sub-menu">
                            {subCategory.children.map(({ category = {} }) => (
                              <li key={category._id}>
                                <Link
                                  to={{
                                    pathname: `/browse/${category.slug}`,
                                  }}
                                >
                                  {getMultiLangProperty(
                                    category.name,
                                    i18n.language
                                  )}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <Link
                            to={{
                              pathname: `/browse/${subCategory.slug}`,
                            }}
                          >
                            {getMultiLangProperty(
                              subCategory.name,
                              i18n.language
                            )}
                          </Link>
                        )}
                      </li>
                    )
                  )}
                </ul>
              ) : (
                <Link
                  to={{
                    pathname: `/browse/${parentCategory.slug}`,
                  }}
                >
                  {getMultiLangProperty(parentCategory.name, i18n.language)}
                </Link>
              )}
            </li>
          ))}

        <li key="blogs">
          <a href="/blogs">{t("home.blogTitle")}</a>
        </li>

        <li key="about">
          <a href="/aboutUs">{t("navMenu.aboutUs")}</a>
        </li>
      </ul>
    </nav>
  );
};

MobileNavMenu.propTypes = {
  strings: PropTypes.object,
};

export default MobileNavMenu;
